import hyperlocalIcon from "../icons/hyperlocal.svg";
import nddIcon from "../icons/ndd.svg";
import sddIcon from "../icons/sdd.svg";
import handoffIcon from "../icons/handoff.svg";

export const statusColors: Record<string, string> = {
	Pending:
		"bg-yellow-100 hover:bg-yellow-200 text-yellow-800 dark:bg-yellow-900 dark:hover:bg-yellow-800 dark:text-yellow-100",
	Accepted:
		"bg-green-100 hover:bg-green-200 text-green-800 dark:bg-green-900 dark:hover:bg-green-800 dark:text-green-100",
	Billed:
		"bg-blue-100 hover:bg-blue-200 text-blue-800 dark:bg-blue-900 dark:hover:bg-blue-800 dark:text-blue-100",
	Transit:
		"bg-indigo-100 hover:bg-indigo-200 text-indigo-800 dark:bg-indigo-900 dark:hover:bg-indigo-800 dark:text-indigo-100",
	Dispatched:
		"bg-purple-100 hover:bg-purple-200 text-purple-800 dark:bg-purple-900 dark:hover:bg-purple-800 dark:text-purple-100",
	Delivered:
		"bg-green-100 hover:bg-green-200 text-green-800 dark:bg-green-900 dark:hover:bg-green-800 dark:text-green-100",
	Transferred:
		"bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100",
	Rejected:
		"bg-red-100 hover:bg-red-200 text-red-800 dark:bg-red-900 dark:hover:bg-red-800 dark:text-red-100",
	Cancelled:
		"bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100",
	RTO: "bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100",
	AWBGenerated:
		"bg-orange-100 hover:bg-orange-200 text-orange-800 dark:bg-orange-900 dark:hover:bg-orange-800 dark:text-orange-100",
	OnHold:
		"bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100",
	Review:
		"bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100",
	Lost:
		"bg-red-100 hover:bg-red-200 text-red-800 dark:bg-red-900 dark:hover:bg-red-800 dark:text-red-100",
	DTO:
		"bg-orange-100 hover:bg-orange-200 text-orange-800 dark:bg-orange-900 dark:hover:bg-orange-800 dark:text-orange-100",
};

const orderStatus = Object.keys(statusColors);

const opsStatus = [
	"Dispatched",
	"Delivered",
	"RTO",
	"InvoiceGenerated",
	"Lost",
	"DTO"
];

export const initialOrderStatus = [
	"Pending",
	"Accepted"
];

const trackOrderStatus = [
	"Pending",
	"Accepted",
	"Rejected",
	"Billed",
	"InvoiceGenerated",
	"Dispatched",
	"Delivered",
];

export enum orderStatusEnum {
	Pending = "Pending",
	Accepted = "Accepted",
	Rejected = "Rejected",
	Billed = "Billed",
	Billing = "Billing",
	Verified = "Verified",
	Cancelled = "Cancelled",
	Dispatched = "Dispatched",
	InDelivery = "InDelivery",
	Transit = "Transit",
	Delivered = "Delivered",
	RTO = "RTO",
	Transferred = "Transferred",
	TransferFailed = "TransferFailed",
	InvoiceGenerated = "InvoiceGenerated",
	OnHold = "OnHold",
	Review = "Review",
	Lost = "Lost",
	DTO = "DTO",
}

const modeIcons: {
	[key: string]: { icon: string; bgColor: string; color: string };
} = {
	hyperlocal: {
		icon: hyperlocalIcon,
		bgColor: "bg-hyperlocalBg",
		color: "text-hyperlocalText",
	},
	ndd: {
		icon: nddIcon,
		bgColor: "bg-nddBg",
		color: "text-nddText",
	},
	sdd: {
		icon: sddIcon,
		bgColor: "bg-sddBg",
		color: "text-sddText",
	},
	store_pickup: {
		icon: handoffIcon,
		bgColor: "bg-orange-100",
		color: "text-orange-600",
	},
};

const entityTypeColors: Record<string, string> = {
	pharmacy: "bg-hyperlocalBg text-hyperlocalText",
	entity: "bg-nddBg text-nddText",
};

const COMPONENT_TYPES = [
	{ value: "banner", label: "Banner" },
	{ value: "card", label: "Card" },
	{ value: "carousel", label: "Carousel" },
	{ value: "categories", label: "Categories" },
	{ value: "suggested_products", label: "Suggested Products" },
] as const;

export const OPENREPLAY_CONFIG = {
	projectKey: process.env.REACT_APP_OPENREPLAY_PROJECT_KEY as string,
	ingestPoint: process.env.REACT_APP_OPENREPLAY_INGEST_POINT as string,
} as const;

export {
	orderStatus,
	trackOrderStatus,
	modeIcons,
	entityTypeColors,
	COMPONENT_TYPES,
	opsStatus,
};

export interface SupabaseUser {
	id: string;
	email: string;
}

export interface AccessLevel {
	access_level: {
		city?: number[];
		state?: number[];
		region?: number[];
		provider_id?: number[];
	};
	entities: string[];
}

export const STORAGE_KEY = "app_user";
export const ACCESS_LEVEL_KEY = "app_access_level";
export const USER_ROLE_KEY = "app_user_role";
export const USER_ENTITIES_KEY = "app_user_entities";
export const ROUTE_PERMISSIONS_KEY = "app_route_permissions";

export const TAG_COLORS = {
	feature: "bg-green-100 text-green-800",
	improvement: "bg-blue-100 text-blue-800",
	fix: "bg-red-100 text-red-800",
	other: "bg-gray-100 text-gray-800",
};

export const ITEMS_PER_PAGE = 10;

export const ChangeLogPointTags = [
	"Feature",
	"Improvement",
	"Bug Fix",
	"Other",
];

export const ORDER_START_DATE = "2025-03-01";

export const PRODUCT_TYPES = ["Rx", "Rx+Free", "Generic", "DPCO"];

export const MASTER_MEDS_COLUMNS = [
	"drugname",
	"drugcode",
	"mrp",
	"brand",
	"manufacturer",
];

export const B2C_MASTER_PRODUCTS_COLUMNS =
	{
		mb_code: "Drugcode",
		product_name: "Drugname",
		medicine_type: "Type",
		packing: "Packing",
		company_name: "Manufacturer",
		mrp: "MRP",
		current_price: "Current Price",
		is_active: "Active",
		discontinued: "Discontinued",
	}

export const UPM_MASTER_PRODUCTS_COLUMNS =
	{
		sku_id: "SKU ID",
		sku_name: "SKU Name",
		mrp_price: "MRP Price",
		units_in_pack: "Units in Pack",
		schedule: "Schedule",
		manufacturer_name: "Manufacturer",
		brand_name: "Brand",
		sku_category_name: "SKU Category",
		pack_form_name: "Pack Form",
		drug_form_name: "Drug Form",
		hsn_name: "HSN",
		consume_type_name: "Consume Type",
		unit_type_name: "Unit Type",
		composition_name: "Composition",
	}


// Hyderabad location
export const MAP_CENTER = {
	lat: 17.4781,
	lng: 78.3916,
};

export const PRODUCT_TYPE_MARGIN_LIMITS: Record<string, number> = {
	DPCO: 20,
	Generic: 60,
	Rx: 30,
	"Rx+Free": 30,
};
